<template>
  <nuxt-link :to="`/kategorier/${content.slug}`">
    <div class="box-content flex items-center p-2 text-center bg-white rounded shadow-md">
      <CImage
        class="shrink-0"
        :src="content.image"
        :alt="content.name"
        height="56"
        width="56"
        :params="{ w: '56', h: '56', fit: 'contain' }"
      />
      <span class="ml-2 text-xs font-bold leading-normal text-left text-primary-900">{{ content.name }}</span>
    </div>
  </nuxt-link>
</template>

<script setup lang="ts">
type Props = {
  content: {
    name: string;
    slug: string;
    image: string;
  };
};

defineProps<Props>();
</script>

<script lang="ts">
export default defineComponent({
  name: 'CategoryCard',
});
</script>
